// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_gk-0";
export var headerCellHover = "_gk-1";
export var readCellContainer = "_gk-2";
export var unreadIndicator = "_gk-3";